var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_1058",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_1058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.44643 16.5C4.15179 16.5 3.89955 16.3951 3.68973 16.1853C3.47991 15.9754 3.375 15.7232 3.375 15.4286V7.67857C3.375 7.38393 3.47991 7.1317 3.68973 6.92188C3.89955 6.71205 4.15179 6.60714 4.44643 6.60714H5.69643V4.89286C5.69643 3.95417 6.02742 3.15402 6.68939 2.49241C7.35137 1.8308 8.15196 1.5 9.09118 1.5C10.0304 1.5 10.8304 1.8308 11.4911 2.49241C12.1518 3.15402 12.4821 3.95417 12.4821 4.89286V6.60714H13.7321C14.0268 6.60714 14.279 6.71205 14.4888 6.92188C14.6987 7.1317 14.8036 7.38393 14.8036 7.67857V15.4286C14.8036 15.7232 14.6987 15.9754 14.4888 16.1853C14.279 16.3951 14.0268 16.5 13.7321 16.5H4.44643ZM4.44643 15.4286H13.7321V7.67857H4.44643V15.4286ZM9.09229 12.9286C9.47124 12.9286 9.79464 12.7974 10.0625 12.5352C10.3304 12.2729 10.4643 11.9576 10.4643 11.5893C10.4643 11.2321 10.3294 10.9077 10.0595 10.6161C9.78964 10.3244 9.46524 10.1786 9.08629 10.1786C8.70733 10.1786 8.38393 10.3244 8.11607 10.6161C7.84821 10.9077 7.71429 11.2351 7.71429 11.5982C7.71429 11.9613 7.84921 12.2738 8.11907 12.5357C8.38893 12.7976 8.71333 12.9286 9.09229 12.9286ZM6.76786 6.60714H11.4107V4.89286C11.4107 4.24801 11.1852 3.6999 10.7343 3.24852C10.2833 2.79712 9.73564 2.57143 9.09139 2.57143C8.44713 2.57143 7.89881 2.79712 7.44643 3.24852C6.99405 3.6999 6.76786 4.24801 6.76786 4.89286V6.60714Z",
    fill: "#8A6CAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.68afcc8f07b2722c237803001e16f06e.svg";
export { ForwardRef as ReactComponent };